import './PartnerWithUs.css'
import React, { useState, useEffect } from "react";
import axios from "axios";
import { AiOutlineCheck } from "react-icons/ai";
import Label from "./image/Label.png";
import Accordion from '../CRP/components/Accordion';
import { FaRegQuestionCircle } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import PartnerWithUsComparison from './PartnerWithUsComparison';
import { Link } from 'react-router-dom';
const url = "https://partywitty.com/master/assets/uploads/";


const faqs = [
    {
        question: " Who can partner with PartyWitty?",
        answer: `We welcome restaurants, bars, lounges, cafes, clubs, banquet halls, and event spaces, who want to increase bookings, host events, or attract a vibrant party-loving crowd.`,
    },
    {
        question: "Is there any registration fee to partner with PartyWitty?",
        answer: (<p>We offer both <strong>free</strong> and <strong>paid plans</strong>. The free plan includes basic listings, while the paid plan offers premium visibility, exclusive leads, and marketing support.</p>)
    },
    {
        question: "What are the benefits of partnering with PartyWitty?",
        answer: (<ul>
            <li>Increased visibility among partygoers and corporates</li>
            <li>Access to <strong>corporate bookings</strong> and group reservations</li>
            <li>Promotion via social media & influencer marketing</li>
            <li>Listing in our CRP (Corporate Recreation Program)</li>
            <li>Curated events & artist collaborations</li>
            <li>Data insights & lead management tools</li>
        </ul>),
    },
    {
        question: " How does the booking process work?",
        answer: " Once a customer submits a booking request, you’ll get notified and can submit your offer through our dashboard. Customers compare offers  and select their preferred option. You’ll receive the confirmed booking details once they pay the advance.",
    },
    {
        question: "How will I receive bookings and leads?",
        answer: "All bookings and leads will be shared with you directly via our Partywitty Partner app.. You will also be notified in real-time.",
    },
    {
        question: "Can I promote my venue’s offers or events through PartyWitty?",
        answer: "Yes! We offer promotional support across our website, app, and social media handles for free. You can highlight deals, happy hours, artist nights, and more.",
    },

    {
        question: "How do I get started?",
        answer: (<p>Simply fill out the registration form <Link href="/business-registration">here</Link>, and our onboarding team will get in touch with you within 24 hours.
        </p>),
    },
    {
        question: "How do payments and commissions work?",
        answer: (<p>We only charge a nominal commission on <strong>successful bookings</strong> made through our platform. There are <strong>no hidden charges</strong> or monthly fees.</p>),
    },
    {
        question: "Who do I contact for support?",
        answer: (<p>You can reach out to our partner support team at <a href="mailto: support@partywitty.com">📧 support@partywitty.com</a> or <a href="https://wa.me/918299619469" target="_blank">📞 +91-8299619469</a>
            for any queries.</p>),
    },
];
export default function PartnerWithUs() {


    const [activeButton, setActiveButton] = useState("monthly");


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [data, setData] = useState([]);
    const [plans, setPlans] = useState({
        monthly: [],
        quarterly: [],
        yearly: [],
    });
    const fetchURL = async () => {
        try {
            const response = await axios.get("https://partywitty.com/master/APIs/Common/getSubscriptionPlan");
            console.log('API Response:', response.data);

            if (response.data && response.data.data && response.data.data.length > 0) {
                const fetchedData = response.data.data[0];

                setPlans({
                    monthly: fetchedData.monthly || [],
                    quarterly: fetchedData.quarterly || [],
                    yearly: fetchedData.yearly || [],
                });
            } else {
                console.log('No data available.');
                setPlans({
                    monthly: [],
                    quarterly: [],
                    yearly: [],
                });
            }
        } catch (error) {
            console.log('API Error:', error);
            setPlans({
                monthly: [],
                quarterly: [],
                yearly: [],
            });
        }
    };
    useEffect(() => {
        fetchURL();
    }, []);
    const handleButtonClick = (frequency) => {
        setActiveButton(frequency);
    };

    const [openIndex, setOpenIndex] = useState(null);
    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };



    return (
        <>
            <div className='partner-with-us-page'>
                <div className="partner-with-us-content-wrapper">

                    <div className='partner-with-us-content'>
                        <h3>Avail Tailor-made Leads at Affordable Prices</h3>
                        <p>Pay For Conversions Only Not For Just Leads</p>
                    </div>

                    <div className="partner-with-us-btn-section">
                        <button
                            className={activeButton === "monthly" ? "active" : ""}
                            onClick={() => handleButtonClick("monthly")}
                        >
                            Monthly
                        </button>
                        {/* <button
                            className={activeButton === "quarterly" ? "active" : ""}
                            onClick={() => handleButtonClick("quarterly")}
                        >
                            Quarterly
                        </button> */}
                        <button
                            className={activeButton === "yearly" ? "active" : ""}
                            onClick={() => handleButtonClick("yearly")}
                        >
                            Annual
                        </button>
                    </div>


                    <div className="partner-with-us-cards-section">

                        <div className={`partner-with-us-cards `}>
                            <div className='partner-with-us-card-content-text'>

                                <h2> Classified </h2>
                                <div className="partner-with-us-card-price">
                                    <p>₹36000 <span>(Taxes Extra)</span></p>
                                </div>
                                <p className="partner-with-us-card-features-title">Key Features</p>
                                <ul>
                                    <li>100 bidding limit per month</li>
                                    <li>Multiple Bidding Attempts (X2) per lead</li>
                                    <li>Bid Price Range 25%</li>
                                    <li>Bidding Rejection Reason</li>
                                    <li>Bid Closure Status</li>
                                    <li>Multiple Package Showcasing</li>
                                    <li>Ala Carte Table Booking @ ₹50 per person ( PostPaid)</li>
                                    <li>Min. Spent guarantee alacarte - 5k & 10k Pivot(prepaid)</li>
                                    <li>Party Witty Pay Charges 3%</li>
                                </ul>

                            </div>
                        </div>

                        {
                            plans[activeButton] && plans[activeButton].length > 0 ? (
                                plans[activeButton].map((plan) => (
                                    <div
                                        key={plan.id}
                                        className={`partner-with-us-cards ${plan.name === 'Gold' ? 'partner-with-us-cards-border' : ''}`}
                                    >

                                        {plan.name === 'Gold' && (
                                            <img className='partner-with-us-card-gold-img' src={Label} alt='img' />
                                        )}
                                        <div className='partner-with-us-card-content-text'>

                                            <h2> <img src={url + plan?.img} alt="" className='partner-with-us-card-img' /> {plan.name} </h2>
                                            <div className="partner-with-us-card-price">
                                                <p>₹{plan.price} <span>(Taxes Extra)</span></p>
                                            </div>
                                            <p className="partner-with-us-card-features-title">Key Features</p>
                                            <p className="partner-with-us-card--description">
                                                {plan.des ? <div dangerouslySetInnerHTML={{ __html: plan.des }} /> : "Description not available"}
                                            </p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No plans available for this frequency.</p>
                            )
                        }
                    </div >


                    <div className='pay-per-conversions-section'>
                        <h1>Pay Per Conversions, Not Per Leads</h1>
                        <p>Boost your club's success with conversion-based charges through WhatsApp interactions. Our commissions are adaptable and customised per conversion, ensuring a flexible solution for turning party seekers into your loyal customers.</p>
                    </div>
                    <div className='how-partyWitty-help-section'>
                        <h1>How PartyWitty Help Your business to grow</h1>

                        <h6>7 x Boost in sales</h6>
                        <p>Access to a wider customer base through PartyWitty's platform can lead to increased bookings for events and parties, translating to higher revenue streams for the club.</p>

                        <h6>Expanded Customer Base</h6>
                        <p>By joining PartyWitty, clubs and bars can tap into a new customer base, attracting individuals and event planners who use the platform to discover and book venues for various social gatherings.</p>

                        <h6>Targeted Marketing and Exposure</h6>
                        <p>Benefit from PartyWitty's marketing efforts and exposure to a specifically targeted audience interested in event hosting. This can enhance the club's visibility and attract party planners looking for suitable venues.</p>

                        <h6>Streamlined Booking Process</h6>
                        <p>PartyWitty provides a user-friendly platform for customers to easily browse and book Group Booking, Table Booking & events. This streamlined process can attract more customers and simplify the reservation process for the club.</p>

                        <h6>Networking Opportunities</h6>
                        <p>Being part of PartyWitty provides networking opportunities with corporate customer base,, businesses, and individuals looking for venues. This can lead to long-term partnerships and repeat business.</p>
                    </div>

                    <div className='who-can-benefit-section'>
                        <h1>Who can benefit from Partywitty?</h1>
                        <div className='who-can-benefit-list'>
                            <p>Party Enthusiasts</p>
                            <p>Corporate Event Planners</p>
                            <p>Restaurants and Cafes</p>
                            <p>Venue Owners and Managers</p>
                            <p>Corporate Event Planners</p>
                            <p>Clubs and Nightlife Venues</p>
                        </div>
                    </div>


                    <div className='partner-with-us-comparison-section-wrapper'>
                        <PartnerWithUsComparison />
                    </div>
                    {/* <div className='partner-with-us-comparison-section'>
                        <h1>Comparison</h1>
                        <table className="partner-with-us-comparison-table-container">
                            <thead>
                                <tr className="partner-with-us-comparison-table-header">
                                    <th></th>
                                    <th>
                                        <div className='partner-with-us-comparison-table-header-content'>
                                            <h3>Silver</h3>
                                            <p className="partner-with-us-trial">(1 Month Free Trail)</p>
                                            <h4>₹24000/-  <span className="partner-with-us-note">(Taxes Extra)</span></h4>

                                            <button className="partner-with-us-select">Select</button>
                                        </div>
                                    </th>
                                    <th>
                                        <div className='partner-with-us-comparison-table-header-content'>
                                            <h3>Gold</h3>
                                            <p className="partner-with-us-trial">(1 Month Free Trail)</p>
                                            <h4>₹36000/-  <span className="partner-with-us-note">(Taxes Extra)</span></h4>

                                            <button className="partner-with-us-select">Select</button>
                                        </div>
                                    </th>
                                    <th>
                                        <div className='partner-with-us-comparison-table-header-content'>
                                            <h3>Classified</h3>
                                            <p className="partner-with-us-trial">(1 Month Free Trail)</p>
                                            <h4>₹48000/-  <span className="partner-with-us-note">(Taxes Extra)</span></h4>

                                            <button className="partner-with-us-select">Select</button>
                                        </div>
                                    </th>
                                    <th>
                                        <div className='partner-with-us-comparison-table-header-content'>
                                            <h3>Platinum</h3>
                                            <p className="partner-with-us-trial">(1 Month Free Trail)</p>
                                            <h4>₹48000/-  <span className="partner-with-us-note">(Taxes Extra)</span></h4>

                                            <button className="partner-with-us-select">Select</button>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Bidding Limit</span></td>
                                    <td>Upto 10 bids/month</td>
                                    <td>100 bids/month</td>
                                    <td>Unlimited</td>
                                    <td>Unlimited</td>
                                </tr>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Bidding Attempts per Lead</span></td>
                                    <td>Single</td>
                                    <td>Multiple (2x)</td>
                                    <td>Unlimited</td>
                                    <td>Unlimited</td>
                                </tr>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Bid Price Range</span></td>
                                    <td>10%</td>
                                    <td>25%</td>
                                    <td>0%</td>
                                    <td>10%</td>
                                </tr>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Bidding Rejection Trend</span></td>
                                    <td>✔️</td>
                                    <td>✔️</td>
                                    <td>✔️</td>
                                    <td>✔️</td>
                                </tr>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Bid Closure Status</span></td>
                                    <td>✔️</td>
                                    <td>✔️</td>
                                    <td>✔️</td>
                                    <td>Venue wise</td>
                                </tr>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Package Showcasing</span></td>
                                    <td>Multiple</td>
                                    <td>Multiple</td>
                                    <td>Multiple</td>
                                    <td>Multiple</td>
                                </tr>
                                <tr className="partner-with-us-comparison-table-row">
                                    <td><span>Party Witty Pay Charges</span></td>
                                    <td>4%</td>
                                    <td>3%</td>
                                    <td>0%</td>
                                    <td>4%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

                    <div className='all-pricing-plans-include-section'>
                        <h1>All Pricing Plans Include</h1>
                        <div className='all-pricing-plans-include-list-container'>
                            <p>✔️ Verified Customers</p>
                            <p>✔️ Menu Display on the Dashboard</p>
                            <p>✔️ Tailor-made Bidding Mechanism</p>
                            <p>✔️ SAAS Model easy lead access</p>
                            <p>✔️ Digital Restaurant/Club Profile</p>
                            <p>✔️ Real-time notifications</p>
                            <p>✔️ Party Photograph Share</p>

                        </div>
                    </div>
                    <div className='partner-with-us-faq'>
                        <div className='partner-with-us-faq-header' onClick={() => toggleAccordion(0)}>
                            <h1> <FaRegQuestionCircle /> Frequently Asked Questions</h1>
                            <span>{openIndex === 0 ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                        </div>
                        {openIndex === 0 && (
                            <Accordion faqs={faqs} defaultOpenIndex={0} />)}
                    </div>
                </div >
            </div >
        </>
    )
}
